<template>
  <header class="main-navbar h-16 bg-white z-navbar">
    <div class="main-navbar-container container pl-5 pr-3 py-3 mx-auto sm:px-0">
      <div class="flex justify-between sm:gap-6">
        <div class="left-group flex items-center flex-1">
          <div class="logo flex-[0_0_auto] lg:mr-14 sm:mr-5">
            <locale-link :class="{ 'pointer-events-none': isInFunNowGroupApp }" to="/">
              <etg-logo width="107" height="40" />
            </locale-link>
          </div>
          <client-only>
            <navbar-region-selector v-if="isIndexPage" />
            <categories-selector v-if="isCategoriesSelectorShown" />
          </client-only>
        </div>

        <div v-if="isActionsShown" class="actions flex items-center justify-end h-10">
          <client-only>
            <navbar-search-button v-if="isNavbarSearchButtonShown" class="flex justify-end flex-1 mr-4 order-1" />
            <download-app-button v-if="isDownloadAppButtonShown" class="order-2" :is-popover-mode="true" />
            <navbar-lang-selector v-if="isLangSelectorShown" class="order-3" />
            <navbar-user-button v-if="isUserButtonShown" class="order-4" />
          </client-only>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useAppStore } from '@/store/app'

const DownloadAppButton = defineAsyncComponent(() =>
  dynamicImport(() => import('@/components/common/download-app-button.vue'), 'download-app-button')
)
const CategoriesSelector = defineAsyncComponent(() =>
  dynamicImport(() => import('@/components/common/categories-selector.vue'), 'categories-selector')
)
const NavbarRegionSelector = defineAsyncComponent(() =>
  dynamicImport(() => import('@/components/navbar/navbar-region-selector.vue'), 'navbar-region-selector')
)
const NavbarSearchButton = defineAsyncComponent(() =>
  dynamicImport(() => import('@/components/navbar/navbar-search-button.vue'), 'navbar-search-button')
)
const NavbarUserButton = defineAsyncComponent(() => dynamicImport(() => import('@/components/navbar/navbar-user-button.vue'), 'navbar-user-button'))
const NavbarLangSelector = defineAsyncComponent(() =>
  dynamicImport(() => import('@/components/navbar/navbar-lang-selector.vue'), 'navbar-lang-selector')
)

const route = useRoute()
const appStore = useAppStore()

const { isInFunNowGroupApp } = useBridge()
const { categoryId } = useCategory()

const isProductListPage = computed(() => checkIfProductListPage(route.name))

const isBookingPage = computed(() => checkIfBookingPage(route.name))
const isIndexPage = computed(() => checkIfIndexPage(route.name))
const isAccountDeletionPage = computed(() => checkIfAccountDeletionPage(route.name))
const isNoShowConfirmPage = computed(() => checkIfNoShowConfirmPage(route.name))

const isActionsShown = computed(() => !isAccountDeletionPage.value)
const isDownloadAppButtonShown = computed(() => appStore.isExtraLargeDesktop && !isBookingPage.value && !isNoShowConfirmPage.value)
const isCategoriesSelectorShown = computed(() => appStore.isDesktopScreen && !!categoryId.value)
const isNavbarSearchButtonShown = computed(() => appStore.isDesktopScreen && isProductListPage.value)
const isLangSelectorShown = computed(() => (!isBookingPage.value && appStore.isExtraLargeDesktop) || isNoShowConfirmPage.value)
const isUserButtonShown = computed(() => !isBookingPage.value && !isNoShowConfirmPage.value)
</script>

<style lang="scss" scoped>
.main-navbar {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
</style>
